(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
  class CategoryShowcaseCarousel {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.cat-showcase__track');
      this.dotsWrap = el.querySelector('.cat-showcase__dots');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.interval = parseInt(el.dataset.autoplay, 10) || 0;
      this.index = 0;
      this.timer = null;
      this.buildDots();
      this.bind();
      this.startAuto();
    }

    buildDots() {
      if (!this.dotsWrap || this.slides.length < 2) return;
      this.slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cat-showcase__dot';
        b.setAttribute('aria-label', 'Ir al producto ' + (i + 1));
        b.addEventListener('click', () => this.go(i, true));
        this.dotsWrap.appendChild(b);
      });
      this.dots = Array.from(this.dotsWrap.children);
      this.updateDots();
    }

    bind() {
      this.el.querySelectorAll('.cat-showcase__nav').forEach((btn) => {
        btn.addEventListener('click', () => this.go(this.index + parseInt(btn.dataset.dir, 10), true));
      });
      let t;
      this.track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const w = this.track.clientWidth || 1;
          this.index = Math.round(this.track.scrollLeft / w);
          this.updateDots();
        }, 90);
      }, { passive: true });
      this.el.addEventListener('mouseenter', () => this.stopAuto());
      this.el.addEventListener('mouseleave', () => this.startAuto());
      this.el.addEventListener('focusin', () => this.stopAuto());
      this.el.addEventListener('focusout', () => this.startAuto());
    }

    go(i, user) {
      const n = this.slides.length;
      if (!n) return;
      this.index = ((i % n) + n) % n;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
      this.updateDots();
      if (user) { this.stopAuto(); this.startAuto(); }
    }

    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
    }

    startAuto() {
      if (!this.interval || this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAuto();
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stopAuto() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  function initCategoryShowcase(root) {
    (root || document).querySelectorAll('.cat-showcase__carousel').forEach((el) => {
      if (!el.__catShowcase) { el.__catShowcase = new CategoryShowcaseCarousel(el); }
    });
  }

  if (document.readyState !== 'loading') {
    initCategoryShowcase();
  } else {
    document.addEventListener('DOMContentLoaded', () => initCategoryShowcase());
  }
  document.addEventListener('shopify:section:load', (e) => initCategoryShowcase(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStory(root) {
      var track = root.querySelector('[id^="Track-"]');
      if (!track) return;
      var slides = Array.from(track.children);
      if (slides.length <= 1) return;

      var currentIndex = 0;
      setInterval(function () {
        currentIndex = (currentIndex + 1) % slides.length;
        track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      }, 5000);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.our-story').forEach(function (el) {
        if (!el.__ourStoryInit) {
          el.__ourStoryInit = true;
          initStory(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(hero) {
      var slides = hero.querySelectorAll('.promo-hero__slide');
      if (slides.length < 2) return;
      var dots = hero.querySelectorAll('.promo-hero__dot');
      var current = 0;
      var delay = parseInt(hero.getAttribute('data-autoplay'), 10);
      if (isNaN(delay)) delay = 5000;
      var timer = null;

      function show(n) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (n + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }
      function next() { show(current + 1); }
      function start() {
        stop();
        if (delay > 0) timer = window.setInterval(next, delay);
      }
      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      for (var i = 0; i < dots.length; i++) {
        (function (idx) {
          dots[idx].addEventListener('click', function () { show(idx); start(); });
        })(i);
      }
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) start();
    }

    function initAll() {
      var heroes = document.querySelectorAll('.promo-hero--slider');
      for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
